import { Component, OnInit, ElementRef, OnDestroy, ChangeDetectionStrategy, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, takeUntil, filter } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { ExploreState } from 'src/app/explore/state/explore.state';
import { Select } from '@ngxs/store';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFieldComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();
  private queryThrottle = 300;
  private minLength = 2;
  private searchRoute = '/explore/search/';
  private _expanded = false;

  @Select(ExploreState.getSearchQuery)
  query$: Observable<string>;

  @Input()
  set expanded(value: boolean) {
    this._expanded = value;
    if (value) {
      setTimeout(() => {
        this.searchInputField.nativeElement.focus();
      });
    }
  } 
  get expanded(): boolean {
    return this._expanded;
  }

  @ViewChild('searchInputField')
  searchInputField: ElementRef;

  searchField: FormControl;

  constructor(
    private router: Router,
    private ref: ChangeDetectorRef
  ) {
    this.searchField = new FormControl('');
  }

  ngOnInit() {
    // sync expanded state
    this.expanded = this.isSearchRoute();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        this.expanded = this.isSearchRoute();
        this.ref.markForCheck();
      });

    // sync query
    this.query$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((query) => {
        this.searchField.setValue(query);
      });

    // delayed search
    this.searchField.valueChanges
      .pipe(
        debounceTime(this.queryThrottle),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((query) => {
        if (query.length >= this.minLength) {
          this.routeSearch(query);
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleToggleClick() {
    this.expanded = !this.expanded;
  }

  handleCloseClick() {
    this.expanded = false;
  }

  routeSearch(query: string) {
    // search is managed by route
    this.router.navigate([this.searchRoute, query], {
      skipLocationChange: false,
      replaceUrl: this.isSearchRoute()
    });
  }

  private isSearchRoute(): boolean {
    return !!this.router.url.match(this.searchRoute);
  }
}
